import { EventEmitter } from 'events';
import { isFunction } from 'lodash';
import * as downloads from './downloads';
export class ResourceProxy {
    eventbus;
    loading;
    url;
    useAuth;
    constructor(app, options) {
        this.loading = false;
        this.eventbus = new EventEmitter();
        this.url = options.url;
        this.useAuth = options.useAuth || false;
    }
    getURL() {
        const url = isFunction(this.url) ? this.url() : this.url;
        return url ? downloads.normalizeLink(url) : null;
    }
    on(event, callback) {
        this.eventbus.addListener(event, callback);
        return this;
    }
    async load() {
        if (this.loading) {
            return;
        }
        const url = this.getURL();
        if (url) {
            try {
                this.loading = true;
                const result = await downloads.getFileBLOB(url);
                this.eventbus.emit('file', result);
            }
            finally {
                this.loading = false;
            }
        }
    }
}
//# sourceMappingURL=resource-proxy.js.map